<template>
  <div class="AboutCard">
    <Nav />
    <img v-if="isPC" class="addressImg" src="../assets/images/about.png" alt="" />
    <img class="phImg" v-else src="../assets/images/map.png" alt="" />
    <div class="contactBox">
      <div class="about-title">
        <el-tabs v-model="activeName" v-if="isPC">
          <el-tab-pane name="first">
            <template #label>
              <span class="cTitle">联系方式</span>
              <span class="eTitle">contact information</span>
            </template>
          </el-tab-pane>
        </el-tabs>
        <span class="text" v-else>联系方式</span>
      </div>
      <div class="contact-Item mt-5">
        <img class="ItemImg" src="../assets/images/phone.png" alt="" />
        <div class="Item">
          <p class="title">热线</p>
          <p>18685038216</p>
        </div>
      </div>
      <div class="contact-Item">
        <img class="ItemImg" src="../assets/images/address.png" alt="" />
        <div class="Item">
          <p class="title">地址</p>
          <p>湖南省长沙县星沙大道未来漫城SOHO国际22层</p>
        </div>
      </div>
      <div class="contact-Item">
        <img class="ItemImg" src="../assets/images/email.png" alt="" />
        <div class="Item">
          <p class="title">申诉邮箱</p>
          <p>2267978078@qq.com</p>
        </div>
      </div>
    </div>
    <div class="about-box">
      <div class="tip-box">
        <div class="form-card">
          <div class="form-container">
            <div class="about-title">
              <el-tabs v-model="activeName" v-if="isPC">
                <el-tab-pane name="first">
                  <template #label>
                    <span class="cTitle">选购化妆品“小提示”</span>
                    <span class="eTitle">Tips for Choosing Cosmetics</span>
                  </template>
                </el-tab-pane>
              </el-tabs>
              <span class="text" v-else>选购化妆品“小提示”</span>
            </div>
            <div class="regulations">
              <span class="number">❶</span>
              <div class="specific">
                <p class="title">根据肤质选择化妆品：</p>
                <p>选购化妆品前，消费者应该对自己肌肤和发质有一定了解，了解自己的实际情况和需求才能更好选择合适自己的化妆</p>
              </div>
            </div>
            <div class="regulations">
              <span class="number">❷</span>
              <div class="specific">
                <p class="title">选择正规途径购买：</p>
                <p>比如超市、百货商场等有合法营业执照的门店或正规电商平台购买化妆品。</p>
              </div>
            </div>
            <div class="regulations">
              <span class="number">❸</span>
              <div class="specific">
                <p class="title">查询产品登记信息：</p>
                <p>通过国家药品监督管理局网站查询化妆品的注册备案情况。</p>
              </div>
            </div>
            <div class="regulations">
              <span class="number">❹</span>
              <div class="specific">
                <p class="title">观察产品质量：</p>
                <p>看看是否有变色，油水分离或长霉斑等现象，闻一闻有没有变味。</p>
              </div>
            </div>
            <div class="regulations">
              <span class="number">❺</span>
              <div class="specific">
                <p class="title">查看成分标识：</p>
                <p>化妆品成分表所标识的成分名称按其在配方中含量由大到小进行顺序，即排位越靠前，表明这个成分在该化妆品的含量越高。</p>
              </div>
            </div>
            <div class="regulations">
              <span class="number">❻</span>
              <div class="specific">
                <p class="title">试用产品：</p>
                <p>取少量产品涂抹在耳朵后面或前臂屈侧处，确定没有刺激或过敏后才购买。</p>
              </div>
            </div>
            <div class="regulations">
              <span class="number">❼</span>
              <div class="specific">
                <p class="title">留存购买凭证：</p>
                <p>购买时索要发票或商场小票，并保留化妆品的包装留作维权时的证据。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="form-card">
          <div class="form-container">
            <div class="about-title">
              <el-tabs v-model="activeName" v-if="isPC">
                <el-tab-pane name="first">
                  <template #label>
                    <span class="cTitle">在线留言</span>
                    <span class="eTitle">Online Message</span>
                  </template>
                </el-tab-pane>
              </el-tabs>
              <span class="text" v-else>在线留言</span>
            </div>
            <el-form class="form" :label-position="labelPosition" :model="form" :rules="rules" ref="form" label-width="110px">
              <el-form-item label="电   话" prop="tel" style="white-space: pre" label-width="80px">
                <el-input v-model="form.tel"></el-input>
              </el-form-item>
              <el-form-item label="传   真" prop="fax" style="white-space: pre">
                <el-input v-model="form.fax"></el-input>
              </el-form-item>
              <el-form-item label="邮   箱" prop="email" style="white-space: pre" label-width="80px">
                <el-input v-model="form.email"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="code">
                <el-input v-model="form.code" auto-complete="off" style="width: 65%" @keyup.enter.native="handleLogin"></el-input>
                <div class="login-code">
                  <img :src="codeUrl" @click="getCode" class="login-code-img" />
                </div>
              </el-form-item>
              <div class="solid" v-if="isPC"></div>
              <el-form-item label="留言内容" prop="content">
                <el-input :rows="4" type="textarea" v-model="form.content"></el-input>
              </el-form-item>
            </el-form>
            <div class="submit">
              <el-button type="primary" @click="submitForm('form')">提交</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer v-if="isPC" class="top" />
    <PhFooter v-else></PhFooter>
  </div>
</template>

<script>
import { addBusiness, getCaptchaImage } from '@/api/index.js'

export default {
  name: 'About',

  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    return {
      labelPosition: 'right', // 默认设置为 "top"
      codeUrl: '',
      form: {
        name: '',
        code: '',
        uuid: ''
      },
      activeName: 'first',
      outerWidth: window.innerWidth, // 屏幕宽度
      rules: {
        content: [{ required: true, message: '请输入留言内容', trigger: 'blur' }],
        tel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isPC() {
      return this.outerWidth > 768
    }
  },
  created() {
    this.getCode()
  },
  mounted() {
    // 在页面加载时检查屏幕宽度
    this.updateLabelPosition()
    // 监听窗口大小变化
    window.addEventListener('resize', this.updateLabelPosition)
  },
  beforeDestroy() {
    // 移除事件监听器，避免内存泄漏
    window.removeEventListener('resize', this.updateLabelPosition)
  },

  methods: {
    // 获取验证码
    getCode() {
      getCaptchaImage().then((res) => {
        this.codeUrl = 'data:image/gif;base64,' + res.data.img
        this.form.uuid = res.data.uuid
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addBusiness(this.form)
            .then((response) => {
              console.log('API请求成功:', response)
              this.$message.success('申请提交成功')
              this.resetForm(formName)
              this.getCode()
            })
            .catch((response) => {
              console.error('API请求失败:', response)
              // this.$message.error(response.msg)
              this.getCode()
            })
        } else {
          console.log('表单验证失败')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    updateLabelPosition() {
      // 根据屏幕宽度设置 label-position
      this.outerWidth = window.innerWidth
      this.labelPosition = window.innerWidth < 768 ? 'top' : 'right'
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__item {
  margin-bottom: 12px;
}

::v-deep .el-tabs__active-bar {
  width: 60px !important;
  height: 4px;
}
::v-deep .el-form-item__label {
  font-size: 20px;
  color: #000000;
  line-height: 33px;
}
.AboutCard {
  font-family: PingFangSC, PingFang SC;
}
.addressImg {
  position: relative;
}
.contactBox {
  position: absolute;
  top: 210px;
  left: 50%;
  transform: translateX(-50%);
  .contact-Item {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    margin-bottom: 30px;
    .ItemImg {
      width: 24px;
      margin-right: 10px;
    }
    .title {
      font-weight: 500;
    }
  }
}
.about-title {
  padding: 0 0 30px 0;
  width: 1200px;
  .cTitle {
    font-weight: 600;
    font-size: 30px;
    color: #000000;
    line-height: 42px;
    margin-right: 15px;
  }
  .eTitle {
    font-size: 24px;
    color: #000000;
    line-height: 33px;
  }
}

.about-box {
  background: #fff;
  font-family: PingFangSC, PingFang SC;
  flex: 1; // Allow the container to grow and fill available space
}

.tip-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.form-card {
  width: 1200px;
  margin-top: 40px;
}
.number {
  color: #2981e2;
  margin-right: 10px;
  line-height: 24px;
}
.form-container {
  max-width: 1300px; // 设置表单容器的最大宽度
  margin: 0 auto; // 将表单容器居中对齐
}
.form {
  display: flex;
  flex-wrap: wrap;
  .solid {
    margin-top: 50px;
    width: 1200px;
    height: 1px;
    border: 1px dashed rgba(0, 0, 0, 0.2);
  }
  .el-form-item:last-child {
    width: 100%; /* 让第一项宽度为 100% */
    margin-top: 44px;
  }
  .el-form-item:not(:last-child) {
    width: 50%; /* 其余项宽度为 50% */
  }
  .login-code {
    width: 33%;
    height: 40px;
    float: right;
    img {
      cursor: pointer;
      width: 160px;
      height: 40px;
      vertical-align: middle;
    }
  }
}
.submit {
  width: 100%;
  text-align: center;
  margin: 30px 0 118px 0;
  button {
    width: 458px;
    height: 48px;
    border-radius: 24px;
  }
}

.regulations {
  display: flex;
  margin-left: 33px;
  margin-bottom: 10px;
  .specific {
    font-size: 16px;
    color: #000000;
    line-height: 24px;
    .title {
      font-weight: bold;
    }
  }
}

@media (max-width: 768px) {
  ::v-deep .el-form-item__label {
    font-size: 13px;
    color: #333;
    line-height: 16px;
  }
  .phImg {
    width: 348px;
    position: relative;
    margin: 12px auto;
    display: flex;
    justify-content: center;
  }
  // 联系我们样式
  .contactBox {
    position: absolute;
    top: 85px;
    left: 50%;
    width: 316px;
    transform: translateX(-50%);
    .contact-Item {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      line-height: 16px;
      margin-bottom: 10px;
      .Item {
        display: flex;
      }
      .ItemImg {
        width: 22px;
        margin-right: 5px;
      }
      .title {
        font-weight: 500;
        margin-right: 5px;
      }
    }
    .mt-5 {
      margin-top: 50px;
    }
  }
  .about-title {
    margin: 14px 0 22px;
    padding: 0;
    width: 100%;
    text-align: center;
  }
  .text {
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    margin: auto;
    font-weight: bold;
  }
  // 小提示样式
  .about-box {
    background: none;
    width: 348px;
    margin: auto;
  }
  .form-card {
    width: 348px;
    margin-top: 0px;
    background: #fff;
    margin-bottom: 12px;
  }
  .regulations {
    margin-left: 0px;
    margin-bottom: 7px;
    .specific {
      font-size: 12px;
      color: #000000;
      line-height: 17px;
      .title {
        font-weight: bold;
        margin-bottom: 5px;
      }
    }
  }
  .number {
    color: #2981e2;
    margin-right: 5px;
    line-height: 18px;
  }
  .form-container {
    width: 314px;
    margin-bottom: 10px;
  }
  // 留言卡片样式
  .form {
    display: unset; /* 或者 initial */
    .el-form-item:last-child {
      width: 321px; /* 让第一项宽度为 100% */
      margin: 0 auto 15px;
    }

    .el-form-item:not(:last-child) {
      margin: auto;
      margin-bottom: 15px;
      width: 321px; /* 其余项宽度为 50% */
    }
    .el-form-item {
      margin-bottom: 15px;
    }

    .login-code {
      width: 33%;
      float: right;
      img {
        width: 100%;
        height: 40px;
        cursor: pointer;
        vertical-align: middle;
        object-fit: cover;
      }
    }
  }
  .submit {
    width: 100%;
    text-align: center;
    margin: 9px 0 13px 0;
    button {
      width: 321px;
      height: 40px;
      border-radius: 5px;
    }
  }
  .tip-box {
    padding-bottom: 20px;
  }
}
</style>
<style lang="scss">
@media (max-width: 768px) {
  #app {
    background: rgba(170, 212, 250, 0.1);
  }
}
</style>
